import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";

function IncompleteIcon() {
  return (
    <ExclamationCircleOutlined
      style={{
        color: "#fa8c16",
      }}
    />
  );
}

export default IncompleteIcon;
